import { render, staticRenderFns } from "./Ponentes.vue?vue&type=template&id=1b355fd7&"
import script from "./Ponentes.vue?vue&type=script&lang=js&"
export * from "./Ponentes.vue?vue&type=script&lang=js&"
import style0 from "./Ponentes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports